import { render, staticRenderFns } from "./hideRelatedItems.vue?vue&type=template&id=648a5ef0&scoped=true"
import script from "./hideRelatedItems.vue?vue&type=script&lang=js"
export * from "./hideRelatedItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648a5ef0",
  null
  
)

export default component.exports